import React from "react";
import EggAudio from "./Eggboy_v3.mp3";

export default function Audplay() {
  return (
    <audio controls src={EggAudio} autoPlay className="audio">
      Your browser does not support the
      <code>audio</code> element.
    </audio>
  );
}
